import { Component, signal } from '@angular/core';
import { environment } from 'src/environments/environment';
import { register } from 'swiper/element/bundle';
import { PingService } from './services/ping.service';
import { AuthService } from './services/auth.service';
import { Platform } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { Keyboard } from '@capacitor/keyboard';
import { Capacitor, PluginListenerHandle } from '@capacitor/core';

register();

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    standalone: false
})
export class AppComponent
{

	public isKeyboardShowing = signal(false);
	private resumeSubscription: Subscription;
	private keyboardListenerHandles: PluginListenerHandle[] = [];

	constructor(
		private platform: Platform,
		private pingService: PingService,
		private authService: AuthService
	)
	{
	}

	async initialiseKeyboard()
	{
		if (!Capacitor.isNativePlatform() || !Capacitor.isPluginAvailable('Keyboard'))
		{
			return;
		}

		this.keyboardListenerHandles = [
			await Keyboard.addListener('keyboardWillShow', () =>
			{
				this.isKeyboardShowing.set(true);
				const tabBar = document.querySelector('ion-tab-bar') as HTMLElement;
				if (tabBar)
				{
					tabBar.classList.add('tab-bar-hidden');
				}
			}),
			await Keyboard.addListener('keyboardDidHide', () =>
			{
				this.isKeyboardShowing.set(false);
				//search for tab-bar-hidden and remove it
				const tabBar = document.querySelector('ion-tab-bar.tab-bar-hidden') as HTMLElement;
				if (tabBar)
				{
					tabBar.classList.remove('tab-bar-hidden');
				}
			})
		];
	}


	ngOnInit()
	{
		const brand = environment.brand;
		document.body.classList.toggle('lazboy', brand == 'L');
		document.body.classList.toggle('hunter', brand == 'H');

		this.platform.ready().then(() =>
		{
			this.initialiseKeyboard();

			// Start the ping system after platform is ready
			this.pingService.startPingSystem();


			// Handle app resume - restart ping interval
			this.resumeSubscription = this.platform.resume.subscribe(() =>
			{
				this.pingService.restartPingInterval();
			});
		});

	}

	ngOnDestroy()
	{
		this.pingService.stopPingSystem();

		if (this.resumeSubscription)
		{
			this.resumeSubscription.unsubscribe();
		}

		this.keyboardListenerHandles.forEach((handle) => handle.remove());
	}
}
